module.exports = __webpack_public_path__ + "assets/img/6565526835f116714bd2bbeb63600a6c.png";